export default __webpack_public_path__ + "static/media/avatar_xiao_mei8.aa3d2dbf.mp3";